export const versionInfo = {
  version: "v0.7.1",
  buildDate: "25.05.2026",
  author: "Dirk & Patrick Lammers"
}
